/**
 * Masks column values using query-logging rules.
 * ID values and falsy values remain visible; other values are redacted.
 */
export function maskColumnValue(value: unknown, columnName?: string): unknown {
  return !value || (columnName && /id/i.test(columnName)) ? value : '***'
}
